import FormHeader from '../components/FormHeader';
import Phone from '../components/Phone';
import PrimaryButton from '../components/Submit';
import Text from '../components/Text';

type IProps = {
  onNext: () => void;
  currentIndex: number;
  totalSteps: number;
};

function PersonalDetails(props: IProps) {
  return (
    <div className="form-container">
      <FormHeader title="Personal Details" />
      <form action="#" method="POST" onSubmit={(e) => e.preventDefault()}>
        <Text
          label="First Name"
          placeholder="Enter your first name"
          id="firstName"
          fullWidth={true}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          name="firstName"
        />

        <Text
          label="Last Name"
          fullWidth={true}
          placeholder="Enter your last name"
          id="lastName"
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          name="lastName"
          validatemessage={''}
        />

        <Text
          label="Date of birth"
          placeholder="Enter your date of birth"
          id="dob"
          fullWidth={true}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          name="dob"
          type={'date'}
        />

        <Phone
          label="Phone Number"
          countryOptions={[{ value: '+1' }, { value: '+44' }, { value: '+91' }]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          phoneId="phoneNumber"
          phoneName="phoneNumber"
          countryCodeId="countryCode"
          value=""
          countryCodeName="countryCode"
          validatemessage={''}
        />

        <PrimaryButton type="button" onClick={props.onNext} loading={false}>
          Next
        </PrimaryButton>
      </form>
    </div>
  );
}

export default PersonalDetails;
